import React, { Component } from 'react';
import UprinceNavigation from '../../shared/uprinceNavigation/cuProjectNavigation/component';
import CuVisualPlanMainLayout from './cuVisualPlanMainLayout';
import { getContractingUnit, getProject } from '../../shared/util';


interface Props {
  currentUser: any
}

interface State {
  isContractUnit: boolean;
  isProject: boolean;
}

class cuProjectVisualPlan extends Component<Props, State> {
  render() {
    return (
      <UprinceNavigation
        currentUser={this.props.currentUser}
        selectedNavigationIndex={`/CU/${getContractingUnit()}/cu-project-planning`}
      >
        <CuVisualPlanMainLayout/>

      </UprinceNavigation>
    );
  }
}

export default cuProjectVisualPlan;
